import { EBaseTextColor } from '@spinwise/react-component-library/BaseText';

export enum EBrandTextColor {
  Subtitle = 'txt-color--subtitle',
  Header = 'txt-color--header',
  Header05 = 'txt-color--header-05',
  Link = 'txt-color--link',
  Alpha = 'txt-color--alpha',
  Alpha30 = 'txt-color--alpha-30',
  White04 = 'txt-color--white-04',
  White05 = 'txt-color--white-05',
  White06 = 'txt-color--white-06',
  White07 = 'txt-color--white-07',
  White08 = 'txt-color--white-08',
  Black = 'txt-color--black',
  Black01 = 'txt-color--black-01',
  Black02 = 'txt-color--black-02',
  White = 'txt-color--white',
  Title = 'txt-color--title',
  TitleDisabled = 'txt-color--title-disabled',
  TopNav = 'txt-color--top-nav',
  Green = 'txt-color--green',
  Epsilon40 = 'txt-color--epsilon-40',
  Black06 = 'txt-color--black-06',
  Black03 = 'txt-color--black-03',
  Black04 = 'txt-color--black-04',
  Black05 = 'txt-color--black-05',
  Black07 = 'txt-color--black-07',
  Black08 = 'txt-color--black-08',
  Black09 = 'txt-color--black-09',
  PinkLink = 'txt-color--pink-link',
  Custom01 = 'txt-color--custom-01',
  Custom02 = 'txt-color--custom-02',
  Custom03 = 'txt-color--custom-03',
  DarkBlue = 'txt-color--dark-blue',
  LightBlue = 'txt-color--light-blue',
  LightPurple = 'txt-color--light-purple',
  LightBlueDBE3FC = 'txt-color--light-blue-dbe3fc',
  LightBlueB4BFE3 = 'txt-color--light-blue-b4bfe3',
  Base = 'txt-color--base',
  BasePrimary = 'txt-color--base-primary',
  Section = 'txt-color--section',
  Subsection = 'txt-color--sub-section',
  ShowAll = 'txt-color--show-all',
  NoFoundTitle = 'txt-color--no-found-title',
  Purple = 'txt-color--purple',
  PurpleDefault = 'txt-color--purple-default',
  PurpleDark = 'txt-color--purple-dark',
  PurpleLight = 'txt-color--purple-light',
  Violet = 'txt-color--violet',
  DarkViolet = 'txt-color--dark-violet',
  Disclaimer = 'txt-color--disclaimer',
  SessionTimer = 'txt-color--session-timer',
  Terms = 'txt-color--terms',
  DepositDescription = 'txt-color--deposit-description',
  Iota = 'txt-color--iota',
  Amount = 'txt-color--amount',
  BlackSolid = 'txt-color--black-solid',
  DefaultBlack = 'txt-color--default-black',
  DefaultBlack03 = 'txt-color--default-black-03',
}

export const TypographyLibrary = {
  ...EBrandTextColor,
  ...EBaseTextColor,
};
